<template>
    <div class="contact-section">
        <div class="row justify-content-center">
            <div class="card col-sm-12 col-md-10 col-lg-7">
                <div class="card-body">
                    <div class="navbar navbar-expand boder-bottom">
                        <social-navigation class="mx-auto" :additional-icons="additionalIcons" @hover="onHover">
                        </social-navigation>
                    </div>

                    <div class="alert alert-danger" v-if="!$root.available">
                        Zur Zeit leider nicht für Aufträge verfügbar.
                    </div>

                    <slide-x-right-transition class="">
                    <div class="text-center" v-if="icon">
                        <h3>{{icon.title}}</h3>
                        <a :href="icon.link" target="blank">
                            <span v-if="icon.subtitle">{{icon.subtitle}}</span>
                            <span v-else>{{icon.link}}</span>
                        </a>
                    </div>
                    </slide-x-right-transition>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SocialNavigation from './SocialNavigation';
import ZoomCenterTransition from "vue2-transitions/src/Zoom/ZoomCenterTransition"
import SlideXRightTransition from "vue2-transitions/src/Slide/SlideXRightTransition"

export default {
    data() {
        return {
            icon: null,
            defaultIcon: {
                title: 'Call me … maybe?',
                link: this.$root.contact.phonelink,
                subtitle: this.$root.contact.phone
            },
            additionalIcons: [
                /*{
                icon: 'fa fa-phone',
                title: 'Telefon',
                link: this.$root.contact.phonelink,
                subtitle: this.$root.contact.phone
            },*/ {
                icon: ['fas', 'envelope'],
                title: 'E-Mail',
                link: 'mailto:' + this.$root.contact.email,
                subtitle: this.$root.contact.email
            }]
        }
    },
    components: {
        SlideXRightTransition,
        ZoomCenterTransition,
        SocialNavigation
    },
    methods: {
        onHover(icon) {
            this.icon = icon;
            return;
            if (!icon) {
                this.icon = this.defaultIcon;
            } else {
            }
        }
    }
}
</script>

<style lang="scss">
.contact-section {
    ul.navbar-nav {
        font-size: 200%;
        li {
            margin: 0 1rem;
        }
    }

    margin-bottom: 3rem;

    .card-body {
        min-height: 300px;
    }
}
</style>
